// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%275%27 viewBox=%270 0 8 5%27%3E%3Cpath fill=%27%231E1F23%27 d=%27M0 0l4 5 4-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Search + sort row ─────────────────────────────────────────────────── */

.vqmtkKVcPO90toPBCsns {
    flex-shrink: 0;
    display: flex;
    gap: 10px;
    padding: 12px 16px;
    background: var(--curio-card-bg);
    border-bottom: 1px solid var(--curio-border);
    font-family: var(--curio-font-family);
}

.ZuPZKQCOIiDQztxETAJw {
    flex: 1;
    position: relative;
}

.wn_cBoPB4CTlNlnMTCKB {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    color: var(--curio-text-muted);
    pointer-events: none;
}

.uHZQyuWaLrBMWOJBzRR5 {
    width: 100%;
    box-sizing: border-box;
    height: var(--curio-input-height);
    padding: 0 12px 0 36px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-md);
    outline: none;
}

.uHZQyuWaLrBMWOJBzRR5::placeholder {
    color: var(--curio-text-muted);
}

.uHZQyuWaLrBMWOJBzRR5:focus {
    border-color: var(--curio-top-bar-bg);
}

.ifQkv_Wc1uR6nylbrWWQ {
    flex-shrink: 0;
    width: 120px;
    height: var(--curio-input-height);
    padding: 0 28px 0 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-md);
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
}

/* Narrow drawer (both catalogs go full-width under 640px): the sort select
   drops below the input instead of squeezing it. Lived as a dead \`.searchBar\`
   rule in DatasetCatalogDrawer.module.css, which never declared that class. */
@media (max-width: 640px) {
    .vqmtkKVcPO90toPBCsns {
        flex-wrap: wrap;
    }

    .ifQkv_Wc1uR6nylbrWWQ {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/PackageSearchRow.module.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,sBAAsB;IACtB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iCAAiC;IACjC,sBAAsB;IACtB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,yDAAuL;IACvL,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;;8EAE8E;AAC9E;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* ── Search + sort row ─────────────────────────────────────────────────── */\n\n.searchRow {\n    flex-shrink: 0;\n    display: flex;\n    gap: 10px;\n    padding: 12px 16px;\n    background: var(--curio-card-bg);\n    border-bottom: 1px solid var(--curio-border);\n    font-family: var(--curio-font-family);\n}\n\n.searchWrap {\n    flex: 1;\n    position: relative;\n}\n\n.searchIcon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 14px;\n    height: 14px;\n    color: var(--curio-text-muted);\n    pointer-events: none;\n}\n\n.searchInput {\n    width: 100%;\n    box-sizing: border-box;\n    height: var(--curio-input-height);\n    padding: 0 12px 0 36px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    outline: none;\n}\n\n.searchInput::placeholder {\n    color: var(--curio-text-muted);\n}\n\n.searchInput:focus {\n    border-color: var(--curio-top-bar-bg);\n}\n\n.sortSelect {\n    flex-shrink: 0;\n    width: 120px;\n    height: var(--curio-input-height);\n    padding: 0 28px 0 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5'%3E%3Cpath fill='%231E1F23' d='M0 0l4 5 4-5z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n}\n\n/* Narrow drawer (both catalogs go full-width under 640px): the sort select\n   drops below the input instead of squeezing it. Lived as a dead `.searchBar`\n   rule in DatasetCatalogDrawer.module.css, which never declared that class. */\n@media (max-width: 640px) {\n    .searchRow {\n        flex-wrap: wrap;\n    }\n\n    .sortSelect {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchRow": `vqmtkKVcPO90toPBCsns`,
	"searchWrap": `ZuPZKQCOIiDQztxETAJw`,
	"searchIcon": `wn_cBoPB4CTlNlnMTCKB`,
	"searchInput": `uHZQyuWaLrBMWOJBzRR5`,
	"sortSelect": `ifQkv_Wc1uR6nylbrWWQ`
};
export default ___CSS_LOADER_EXPORT___;
